import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/dymaczew/Documents/_code/mcm/cp4mcm-demohub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Cloud Pak for Multicloud Management`}</h2>
    <p>{`The TechZone Team provides the ability to provision OCP clusters where you can install your own instance of IBM Cloud Pak for Multicloud management.`}</p>
    <p>{`You can either use the installer available in Catalog in IBM Cloud `}<a parentName="p" {...{
        "href": "https://cloud.ibm.com/catalog/content/ibm-cp-management::1-2c621076-b5eb-489d-ae92-c63f13d713ef-global"
      }}>{`here`}</a>{` or use the community installer available in the `}<a parentName="p" {...{
        "href": "https://github.com/ibm-garage-tsa/cp4mcm-installer"
      }}>{`GitHub`}</a></p>
    <p>{`Bear in mind that tutorials available on this site were developed for version 2.1, so some details may be change for newer versions.`}</p>
    <p>{`If you have any issues or feedback, please share it with tutorial authors. Enjoy it!!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      